import { recipe } from '@vanilla-extract/recipes';
import { vars } from '../../theme/contract.css';

export const kbd = recipe({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: vars.surface.highlight.faint,
    border: `1px solid ${vars.surface.border.secondary}`,
    borderRadius: vars.spacing.borderRadius.xs,
    color: vars.typography.textColor.secondary,
    fontFamily: vars.typography.fontFamily.mono,
    fontWeight: vars.typography.fontWeight.medium,
    lineHeight: 1,
    whiteSpace: 'nowrap',
  },
  variants: {
    size: {
      sm: {
        minWidth: '18px',
        height: '18px',
        padding: '0 4px',
        fontSize: '10px',
      },
      md: {
        minWidth: '22px',
        height: '22px',
        padding: '0 6px',
        fontSize: '12px',
      },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});
